import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import styled from "styled-components";

export const ContentContainer = styled.div`
	padding: ${({ padding }) => (padding ? padding : "1rem 0")};
	display: flex;
	flex-direction: ${({ flexDirection }) => flexDirection};
	flex-wrap: ${({ flexWrap }) => flexWrap};
	width: ${({ width }) => width};
	max-width: ${({ maxWidth }) => maxWidth};
	flex-basis: ${({ flexBasis }) => flexBasis};
	flex-grow: ${({ flexGrow }) => flexGrow};
	margin: ${({ margin }) => margin};
	justify-content: ${({ justifyContent }) => justifyContent};
	transition: ${({ transition }) => transition};
	align-items: ${({ alignItems }) => alignItems};
	${media.lessThan(breakpoints.mobile)`
		padding: ${({ smallPadding }) => smallPadding};
		width: 100%;
		margin: 0;
	align-items: ${({ smallAlignItems }) => smallAlignItems};

		flex-direction: ${({ smallFlexDirection }) => (smallFlexDirection ? smallFlexDirection : "column")};
  `}
`;
export const WrappedItem = styled.div`
	margin-top: 20px;
	border: ${({ border }) => border};
	width: 100%;
	flex-direction: column;
	align-items: ${({ alignItems }) => alignItems};
	justify-content: ${({ justifyContent }) => justifyContent};
	padding: ${({ padding }) => padding};
	border-radius: ${({ theme }) => theme.border.radius};
	background: ${({ background }) => (background ? background : "")};
	display: flex;
	width: auto;
	min-width: 220px;
	flex-grow: 1;
	padding: ${({ smallPadding }) => smallPadding};
	${media.lessThan(breakpoints.mobile)`

	&:first-of-type{
		margin-top: 4px;

	}
`}
	${media.greaterThan(breakpoints.mobile)`
	padding: ${({ padding }) => padding};

		max-width: ${({ margin }) => `calc(50% - ${margin})`};
	margin-left: ${({ margin }) => (margin ? margin : "15px")};

		
	`}
	${media.greaterThan(breakpoints.ipad)`
	max-width: ${({ margin }) => `calc(33% - ${margin})`};
		
		`}
	${media.greaterThan(breakpoints.desktop)`
		max-width: ${({ margin }) => `calc(33% - ${margin})`};
		
		`}
`;

export const WrapperControls = styled.div`
	display: flex;
	gap: 16px;
`
